import { Component, Input, Output, EventEmitter, ElementRef, OnInit } from '@angular/core';
import { PartieDepot } from '../../../entities/requete';

export enum FicheType {
    default = 'default-list',
    resultList = 'result-list',
    addedList = 'added-list'
}

@Component({
    selector: 'jhi-fiche-acteur',
    templateUrl: './fiche-acteur.component.html',
    styleUrls: ['./fiche-acteur.component.scss']
})
export class FicheActeurComponent implements OnInit {

    isOnClickUsed = false;

    @Input()
    acteur: PartieDepot;

    @Input()
    isPrincipal?: boolean;

    type: FicheType;
    FicheTypeEnum = FicheType;

    addr1Line: string;
    addr2Line: string;
    phoneLine: string;

    tooltip: string;

    @Output() onClick = new EventEmitter();
    @Output() onMoveToPrincipal = new EventEmitter();

    onClickIcon() {
        this.onClick.emit();
    }

    onClickToPrincipalButton() {
        this.onMoveToPrincipal.emit();
    }

    constructor(private elementRef: ElementRef) {
        const elt = this.elementRef.nativeElement;
        this.type = elt.getAttribute(FicheType.resultList) != null ? FicheType.resultList
            : elt.getAttribute(FicheType.addedList) != null ? FicheType.addedList : FicheType.default;
    }

    ngOnInit() {
        this.isOnClickUsed = this.onClick.observers.length > 0;
        this.addr1Line = this.acteur.address.adresse1;
        this.addr2Line = `${this.acteur.address.codePostal}&nbsp;${this.acteur.address.ville}, ${this.acteur.address.pays}`;
        if (this.acteur.contact) {
            const phoneSeparator = this.acteur.contact.numeroPortable && this.acteur.contact.numeroFixe ? '&nbsp;- ' : '';
            this.phoneLine = `${this.acteur.contact.numeroPortable || ''}${phoneSeparator}${this.acteur.contact.numeroFixe || ''}`;
        }
        this.setTextForTooltip();
    }

    setTextForTooltip() {
        switch (this.type) {
            case FicheType.resultList:
                this.tooltip = 'Ajouter ce requérant';
                break;
            case FicheType.addedList:
                this.tooltip = 'Supprimer définitivement ce requérant';
                break;
            default:
                this.tooltip = 'Modifier mes informations personnelles';
                break;
        }
    }

}



// WEBPACK FOOTER //
// ./src/main/webapp/app/shared/components/fiche-acteur/fiche-acteur.component.ts